import { forwardRef } from 'react';
import { CardLayout } from '../../lib/card';
import { usePost } from '../Post';
import {
  CardActionsBlock,
  CardContainer,
  CardMediaBlock,
  CardPreviewLinkBlock,
  CardRepostPreviewBlock,
  CardSourceBlock,
  CardTextBlock,
  CardUserBlock
} from '../parts';
import { usePostAction, usePostSettings } from '../utils';

interface Card5Props {
  space: number;
}

export const Card5 = forwardRef<HTMLDivElement, Card5Props>(
  ({ space, ...forwardingProps }, forwardingRef) => {
    const { horizontal, showMedia, showTextLink } = usePost();
    const { backgroundColor, borderRadius, showShadow, shadow } =
      usePostSettings();
    const handleAction = usePostAction();

    return (
      <CardContainer
        {...forwardingProps}
        ref={forwardingRef}
        onClick={handleAction}
        _space={space}
        _backgroundColor={backgroundColor}
        _borderRadius={borderRadius}
        _shadow={showShadow ? shadow : undefined}
      >
        {horizontal ? (
          <CardLayout.Columns>
            <CardLayout.HorizontalCardContentContainer>
              <CardSourceBlock centered />
              <CardTextBlock grow centered />
              {showTextLink && <CardPreviewLinkBlock />}
              <CardRepostPreviewBlock ratio={0.66} />
              <CardUserBlock centered />
              <CardActionsBlock withTopDivider />
            </CardLayout.HorizontalCardContentContainer>

            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}
          </CardLayout.Columns>
        ) : (
          <>
            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}

            <CardSourceBlock centered />
            <CardTextBlock centered />
            <CardRepostPreviewBlock ratio={0.66} />
            {showTextLink && <CardPreviewLinkBlock />}
            <CardUserBlock centered />
            <CardActionsBlock withTopDivider />
          </>
        )}
      </CardContainer>
    );
  }
);

Card5.displayName = 'Card5';
